export const Permissions = {
  roles: {
    create: "roles:create",
    update: "roles:update",
    ["assign-permissions"]: "roles:assign-permissions",
    read: "roles:read",
    delete: "roles:delete",
    duplicate: "roles:duplicate",
  },
  users: {
    read: "users:read",
    invite: "users:invite",
    create: "users:create",
    delete: "users:delete",
    update: "users:update",
    "reset-password": "users:reset-password",
    activate: "users:activate",
    ["assign-role"]: "users:assign-role",
  },
  processes: {
    create: "processes:create",
    publish: "processes:publish",
    update: "processes:update",
    delete: "processes:delete",
    ["assign-flow"]: "processes:assign-flow",
    read: "processes:read",
    archive: "processes:archive",
  },
  tags: {
    create: "tags:create",
    update: "tags:update",
    delete: "tags:delete",
    read: "tags:read",
  },
  flows: {
    read: "flows:read",
    ["configure-access"]: "flows:configure-access",
    create: "flows:create",
    duplicate: "flows:duplicate",
    delete: "flows:delete",
    update: "flows:update",
    preview: "flows:preview",
    ["assign-viewers"]: "flows:assign-viewers",
    ["request-review"]: "flows:request-review",
    ["perform-review"]: "flows:perform-review",
    ["create-version"]: "flows:create-version",
  },
  faqs: {
    read: "faqs:read",
    edit: "faqs:edit",
    create: "faqs:create",
    delete: "faqs:delete",
  },
  ["privacy-policies"]: {
    edit: "privacy-policies:edit",
    create: "privacy-policies:create",
    delete: "privacy-policies:delete",
    view: "privacy-policies:view",
  },
  widgets: {
    activity: "widgets:activity",
    flows: "widgets:flows",
    processes: "widgets:processes",
    pending: "widgets:pending",
    submissions: "widgets:submissions",
    procedures: "widgets:procedures",
    ["in-progress"]: "widgets:in-progress",
    solved: "widgets:solved",
  },
  announcements: {
    read: "announcements:read",
    create: "announcements:create",
    update: "announcements:update",
    delete: "announcements:delete",
    publish: "announcements:publish",
    archive: "announcements:archive",
  },
  "data-center": {
    read: "data-center:read-table",
    create: "data-center:create-table",
    update: "data-center:update-table",
    delete: "data-center:delete-table",
    "read-registry": "data-center:read-registry",
    "create-registry": "data-center:create-registry",
    "update-registry": "data-center:update-registry",
    "delete-registry": "data-center:delete-registry",
  },
  "approval-groups": {
    read: "approval-groups:read",
    create: "approval-groups:create",
    update: "approval-groups:update",
    delete: "approval-groups:delete",
  },
  formality_requests: {
    create: "submissions:create",
    read: "submissions:read",
    assign: "submissions:assign",
    update: "submissions:update",
    delete: "submissions:delete",
    edit: "submissions:edit",
  },
  "node-time-extension-requests": {
    update: "node-time-extension-requests:update",
    read: "node-time-extension-requests:read",
  },
  "email-templates": {
    read: "email-templates:read",
    create: "email-templates:create",
    update: "email-templates:update",
    delete: "email-templates:delete",
  },
  "document-templates": {
    read: "generator-template:read",
    create: "generator-template:create",
    update: "generator-template:update",
    delete: "generator-template:delete",
  },
  "node-deadline-suspensions": {
    read: "node-deadline-suspensions:read",
    create: "node-deadline-suspensions:create",
    update: "node-deadline-suspensions:update",
    delete: "node-deadline-suspensions:delete",
  },
  "node-deadline-suspensions-config": {
    read: "node-deadline-suspension-configs:read",
    create: "node-deadline-suspension-configs:create",
    update: "node-deadline-suspension-configs:update",
    delete: "node-deadline-suspension-configs:delete",
  },
  calendar: {
    read: "calendar:read",
    create: "calendar:create",
    update: "calendar:update",
    delete: "calendar:delete",
  },
  expedient_base_entities: {
    read: "expedient_base_entities:read",
    create: "expedient_base_entities:create",
    update: "expedient_base_entities:update",
    delete: "expedient_base_entities:delete",
  },
  expedient_base_registries: {
    read: "expedient_base_registries:read",
    create: "expedient_base_registries:create",
    update: "expedient_base_registries:update",
    delete: "expedient_base_registries:delete",

    "read-formality": "expedient_base_registries:read-formality-request",
  },
  notifications: {
    update: "notifications:update",
    read: "notifications:read",
    delete: "notifications:delete",
  },
};
